/**
 * Calculates the size in rem units based on the provided size in pixels.
 * @param {number} size - Size in pixels
 * @returns {string} - Size in rem units
 */
export var calculateRem = function (size) { return "".concat(size / 16, "rem"); };
/**
 * Converts pixel value to rem units.
 * @param {string | number} px - Pixel value or size in pixels
 * @returns {number | string} - Converted value in rem units
 */
export var pxtorem = function (px) {
    if (px === 0) {
        return 0;
    }
    return calculateRem(typeof px === 'number' ? px : parseInt(px));
};
/**
 * Calculates the size in em units based on the provided size in pixels.
 * @param {number} size - Size in pixels
 * @returns {string} - Size in em units
 */
export var calculateEm = function (size) {
    var emSize = size / 16;
    return "".concat(emSize, "em");
};
/**
 * Converts pixel value to em units.
 * @param {string} pixelValue - Pixel value
 * @returns {string} - Converted value in em units
 */
export var pxtoem = function (pixelValue) {
    var pixelValueFormatted = parseInt(pixelValue.replace('px', ''));
    return !pixelValue ? 0 : pixelValueFormatted / 16 + 'em';
};
/**
 * Strips the unit (e.g., 'px') from a number string.
 * @param {string} numberString - Number string with unit
 * @returns {string} - Number string without unit
 */
export var stripUnit = function (numberString) {
    return numberString.replace(/[^0-9]/g, '');
};
/**
 * Adds up pixel values in an array and returns the total.
 * @param {string[]} values - Array of pixel values
 * @returns {string} - Total pixel value with 'px' unit
 */
export var addPixelValues = function (values) {
    var total = 0;
    values.map(function (val) {
        total += parseInt(stripUnit(val));
    });
    return total + 'px';
};
